import React, { useEffect, useState, useMemo } from "react";
import {
  faArrowLeft,
  faEdit,
  faMagnifyingGlass,
  faPrint,
  faEyeSlash,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddSubAdmin from "./AddSubAdmin";
import callApi from "services/api";
import { useRecoilState, useSetRecoilState } from "recoil";
import { UserState } from "global/UserState";
import { AlertState } from "global/AlertState";
import { loadingState } from "global/LoaderState";
import { formatDate } from "utils/DateFormatter";
import { getMasterdata } from "../delinquency/apis";
import Swal from "sweetalert2";
const SubAdmin = () => {
  const [showModal, setShowModal] = useState(false);
  const [, setAlertMessage] = useRecoilState(AlertState);
  const [user] = useRecoilState(UserState);
  const [empList, setEmpList] = useState([]);
  const loader = useSetRecoilState(loadingState);
  const [editingData, setEditingData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const limit = 10

  const handleOpenModal = (data = null) => {
    // setEditingData(data);
    setShowModal(true);
  };

  const getEmployeeList = async (page = 1) => {
    try {
      loader(true);
      setLoading(true);
      setError(null);
      const params = new URLSearchParams({
        sort_order: '1',
        page: page.toString(),
        limit: limit.toString(),
      })
      let response = await callApi(
        `auth/users?${params}`,
        "GET",
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log("navigate to", path)
      );

      if (response.success) {
        const body = response?.body || {}
        const employees = response?.body?.data || [];
        setCurrentPage(body.current_page || 1)
        setTotalPages(body.total_pages || 1)
        setTotalRecords(body.total_count || 0)

        const enrichedEmployees = await Promise.all(
          employees.map(async (emp) => {
            const unitData = emp.unit ? await getMasterdata(emp.unit) : null;
            const subUnitData = emp.subUnit
              ? await getMasterdata(emp.subUnit)
              : null;

            return {
              ...emp,
              unit: unitData?.name,
              subUnit: subUnitData?.name,
            };
          })
        );

        setEmpList(enrichedEmployees);
      }
    } catch (err) {
      setError(err.message || "Failed to load employees");
    } finally {
      loader(false);
      setLoading(false);
    }
  };

  const removeUser = async (id) => {
    try {
      loader(true);
      setLoading(true);
      setError(null);

      const params = new URLSearchParams({
        data: id,
      });

      let response;
      response = await callApi(
        `auth/remove?${params}`,
        "DELETE",
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log("navigate to", path)
      );

      if (response.success) {
        getEmployeeList();
      }
    } catch (err) {
      setError(err.message || "Failed to load employees");
    } finally {
      loader(false);
      setLoading(false);
    }
  };

  const handleDeleteUser = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete it!",
      showCancelButton: true,
      confirmButtonColor: "#33B36B",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        removeUser(item);
      }
    });
  };
  useEffect(() => {
    getEmployeeList();
  }, []);
  const handleCloseModal = () => {
    setEditingData(null);
    setShowModal(false);
  };

  const renderRows = () => {
    if (!empList || empList.length === 0) {
      return (
        <tr>
          <td colSpan={7} className="p-3 text-start">
            No Data
          </td>
        </tr>
      );
    }

    return empList.map((item) => (
      <tr key={item.id}>
        <td className="text-center">{item.name}</td>
        <td className="text-center">{item.mobileNumber}</td>
        <td className="text-center">{item.email}</td>
        <td className="text-center">{item.unit}</td>
        <td className="text-center">{item.subUnit}</td>
        <td className="text-center">{item.role}</td>
        <td className="text-center">
          {/* <button
            type="button"
            onClick={() => handleOpenModal()}
            className="btn btn-sm btn-link me-2"
            style={{ textDecoration: 'none' }}
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" />
            Edit
          </button> */}

          {/* <button
            type="button"
            className="btn btn-sm btn-link"
            style={{ textDecoration: 'none' }}
            onClick={() => {
              handlePrint('preet', 'Pr1122', 'pr112')
            }}
          >
            <FontAwesomeIcon icon={faPrint} className="me-1" />
            Print
          </button> */}

          {item?.is_active ? (
            <button
              type="button"
              onClick={() => handleDeleteUser(item.id)}
              className="btn btn-sm btn-link me-2"
              style={{ textDecoration: "none", color: "red" }}
            >
              <FontAwesomeIcon icon={faEdit} className="me-1" />
              Delete
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-sm btn-link me-2"
              style={{ textDecoration: "none", color: "gray" }}
            >
              <FontAwesomeIcon icon={faEdit} className="me-1" />
              Deleted
            </button>
          )}
        </td>
      </tr>
    ));
  };

  const handlePrint = (name, username, password) => {
    const printContent = `
      <!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Login Credentials</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            background-color: #f4f4f4;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
        }
        .container {
            background: #ffffff;
            padding: 25px;
            border-radius: 10px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            width: 350px;
        }
        h2 {
            color: #333;
            margin-bottom: 15px;
        }
        p {
            font-size: 16px;
            color: #555;
            margin: 10px 0;
        }
        .highlight {
            font-weight: bold;
            color: #007bff;
        }
        .note {
          color: red;
        }    
    </style>
</head>
<body>
    <div class="container">
        <p>Dear ${name},</p>
        <p>Your login credentials are as follows:</p>
        <p><strong>Username:</strong> <span class="highlight">${username}</span></p>
        <p><strong>Login Password:</strong> <span class="highlight">${password}</span></p>
        <p class="note">Note: Please keep your credentials safe and do not share them with anyone.</p>
    </div>
</body>
</html>

    `;

    const printWindow = window.open("", "", "width=600,height=400");
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <>
      <div className="ms-3 me-3 mt-3 d-flex justify-content-between bg-dark rounded ">
        <h5 className="card-title  p-3 m-0 text-white">User Generation</h5>
        <button
          type="button"
          className="btn btn-sm text-white me-2"
          onClick={() => handleOpenModal()}
          style={{ textDecoration: "none" }}
        >
          <FontAwesomeIcon icon={faEdit} className="me-1" />
          Add User
        </button>
      </div>
      <div className="card-body ms-3">
        <>
          <div className="row mb-3 mt-4 ps-4">
            <form className="form-inline d-flex">
              <div className="col-md-4">
                <div
                  className="position-relative w-100"
                  style={{ maxWidth: "400px" }}
                >
                  {/* Search Icon */}
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                    style={{ pointerEvents: "none" }} // icon won’t block clicks
                  />

                  {/* Search Input */}
                  <input
                    type="text"
                    name="questionName"
                    //    onChange={handleSearchChange}
                    placeholder="Type a name for search"
                    className="form-control ps-5 py-2"
                    style={{
                      borderRadius: "0.5rem",
                      boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="text-center">Name</th>
                  <th className="text-center">Mobile Number</th>
                  <th className="text-center">Email</th>
                  <th className="text-center">Unit</th>
                  <th className="text-center">Sub Unit</th>
                  <th className="text-center">Role</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderRows()}</tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-3">

            <div>
              Page {currentPage} of {totalPages} | Total Records: {totalRecords}
            </div>

            <div>
              <button
                disabled={currentPage === 1}
                onClick={() => getEmployeeList(currentPage - 1)}
                className="btn btn-sm btn-outline-primary me-2"
              >
                Previous
              </button>

              <button
                disabled={currentPage === totalPages}
                onClick={() => getEmployeeList(currentPage + 1)}
                className="btn btn-sm btn-outline-primary"
              >
                Next
              </button>
            </div>

          </div>
          {
            <AddSubAdmin
              showModal={showModal}
              handleCloseModal={handleCloseModal}
              editingData={editingData}
              fetchEmployees={getEmployeeList}
            />
          }
          {/* <AddEmployee
               showModal={showModal}
               fetchEmployees={getEmployeeList}
               handleCloseModal={handleCloseModal}
               editingData={editingData}
             /> */}
        </>
      </div>
    </>
  );
};

export default SubAdmin;
